import { render } from "./OrderPaymentOptions.vue?vue&type=template&id=5f1f459b"
import script from "./OrderPaymentOptions.vue?vue&type=script&lang=js"
export * from "./OrderPaymentOptions.vue?vue&type=script&lang=js"
script.render = render

export default script